module.exports = __webpack_public_path__ + "static/img/icon-ai.8a7a1257.png";